// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-row[data-v-eda0e23a] {\n  background: rgba(232, 238, 241, 0.4);\n  border: 1px solid #e8eef1;\n}\n.header-row .service-meta[data-v-eda0e23a] {\n  color: #A6A4A6;\n}\n.header-row .source-text[data-v-eda0e23a] {\n  color: #0E6488;\n}", ""]);
// Exports
module.exports = exports;
